import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, RangeControl } from '@wordpress/components';
import { t } from "drupal";

const SidePanel = ({ numCols, updateNumCols, firstBlockType }) => {

    return (
        <InspectorControls>
            <PanelBody title={t('Settings', 'deohs-gutenberg-blocks')}>
                <RangeControl
                    label={t('Number of Columns per Row', 'deohs-gutenberg-blocks')}

                    value={numCols}
                    onChange={updateNumCols}
                    min={1}
                    max={2}

                />
                <p>Select the number of profile cards per column. 1 is placed by default.</p>
            </PanelBody>
        </InspectorControls>
    );
};

export default SidePanel;
